// removed by extract-text-webpack-plugin
module.exports = {"container":"Layout__container__3-kwi","header":"Layout__header__3lwl6","body":"Layout__body__3UJJY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StaticPages/Layout.scss
// module id = 686
// module chunks = 0